import {
  Modal,
  type ModalProps,
} from "@tokenterminal/core/ui/overlays/modal/Modal"
import { Box } from "@tokenterminal/ui/Box"
import { Loading } from "@tokenterminal/ui/Loading/Loading"
import { Suspense } from "react"
import { centerCss } from "styles/center.css"
import { type ZoomValues } from "../Zoom/constants"
import {
  ChartFormulaFinancialStatementModalContent,
  ChartFormulaModalContent,
} from "./ChartFormulaModalContent"

export function LazyChartFinancialStatementFormulaModal({
  onClose,
  project,
  granularity,
  isOpen,
  setIsOpen,
}: Omit<ModalProps, "children"> & {
  project: string
  onClose: () => void
  granularity: string
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}) {
  return (
    <Modal size="large" isOpen={isOpen} onOpenChange={setIsOpen}>
      <Suspense
        fallback={
          <Box className={centerCss}>
            <Loading />
          </Box>
        }
      >
        <ChartFormulaFinancialStatementModalContent
          onClose={onClose}
          project={project}
          granularity={granularity}
        />
      </Suspense>
    </Modal>
  )
}

export function LazyChartFormulaModal({
  onClose,
  series,
  zoom,
  singleProject,
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  onClose: () => void
  series: Array<{
    metrics: Array<string | undefined>
    projects: Array<string>
  }>
  zoom: ZoomValues
  singleProject?: boolean
}) {
  return (
    <Modal size="large" isOpen={isOpen} onOpenChange={setIsOpen}>
      <Suspense
        fallback={
          <Box className={centerCss}>
            <Loading />
          </Box>
        }
      >
        <ChartFormulaModalContent
          series={series}
          zoom={zoom}
          onClose={onClose}
          singleProject={singleProject}
        />
      </Suspense>
    </Modal>
  )
}
